<template>
    <div id="" class="srContent srContentView">
        <!-- <div class="sortBox" v-show="tabType != 1">
            <div :class="isNewClick?'newBg sortNew sortFlex':'sortNew sortFlex'" @click="Sort(1)">最新
                <img src="/static/images/sortUped.png" alt=""  v-if="isNewClick">
                <img src="/static/images/sortUp.png" alt="" v-else>
            </div>

        </div> -->

        <div class="areaTabBox">
            <div :class="tab1?'tabItem xuet tabActive':'tabItem xuet'" @click="choseTab(1)">学堂资源</div>
            <div :class="tab2?'tabItem tabActive':'tabItem'" @click="choseTab(2)">全国资源</div>
            <div :class="tab3?'tabItem tabActive':'tabItem'" @click="choseTab(3)">区域资源</div>
            <div :class="tab4?'tabItem tabActive':'tabItem'" @click="choseTab(4)">校本资源</div>
            <div :class="tab5?'tabItem tabActive':'tabItem'" @click="choseTab(5)">我的资源</div>
        </div>
        <!-- 数据为空时显示 组件 -->

        <div class="uploadBox">
            <div class="material">共{{pageTotal}}份资源</div>
            <div class="upload" @click="upLoad" v-show="tabType == 5&&level == 4" v-if="userType != 'student'">
                <img src="/static/images/upload.png" alt="">上传资源
            </div>
        </div>
        <empty v-if="isEmpty"></empty>
        <List v-if="!isEmpty">

            <div class="listItem"  v-for="(item,index) in dataInfo" :key="index">
                <div class="avatar">
                    <img src="/static/images/ppt.png" v-show="item.type == 2" alt="">
                    <img src="/static/images/wordImg.png" v-show="item.type == 3" alt="">
                    <img src="/static/images/video.png" v-show="item.type == 1" alt="">
                    <img src="/static/images/mp3Img.png" v-show="item.type == 4" alt="">
                </div>
                <div class="description">
                    <div class="itemTitle" @click="palyVideo(item.analysis,item.name,1,item.id)" v-if="item.type == 1">{{item.fileName || item.name}}</div>
                    <!-- <div class="itemTitle" @click="view(item.analysis)" v-else-if="item.type == 2">{{item.fileName || item.name}}</div>
                    <div class="itemTitle" @click="view(item.analysis)" v-else-if="item.type == 3">{{item.fileName || item.name}}</div> -->
                    <div class="itemTitle" @click="view(item.analysis,item.id,item.name,2,item.type,2,3)" v-else>{{item.fileName || item.name}}</div>
                    <!-- <div class="itemPlace" v-if="tabType != 1">
                        <div class="itemAuthor">作者：{{}}</div>
                        <div class="itemSchool">所属院校：清华大学</div>
                    </div> -->
                    <div class="itemNumber">
                        <div class="itemTime">上传时间：{{item.createTime}}</div>
                        <div class="itemAuthor" v-if="tabType != 1 && tabType != 5">作者：{{item.teacherName}}</div>
                        <div class="itemAuthor" v-if="tabType != 1 && tabType != 5" style="padding-left:30px;">所属院校：{{item.teacherSchool}}</div>
                        <div class="itemAuthor"  v-show="tabType == 5">
                            共享范围：{{item.shareNetId == 0 && item.shareSchoolId == 0 && item.shareWebsiteId == 0?'未共享':item.shareNetId != 0 && item.shareSchoolId == 0
                                && item.shareWebsiteId == 0?'全国':item.shareNetId != 0 && item.shareSchoolId != 0
                                && item.shareWebsiteId == 0 ? '全国 校本' :item.shareNetId != 0 && item.shareSchoolId != 0
                                && item.shareWebsiteId != 0 ? '全国 区域 校本' :item.shareNetId == 0 && item.shareSchoolId != 0
                                && item.shareWebsiteId == 0 ? '校本':item.shareNetId == 0 && item.shareSchoolId != 0
                                && item.shareWebsiteId != 0 ? '区域 校本' : item.shareNetId == 0 && item.shareSchoolId == 0
                                && item.shareWebsiteId != 0 ? '区域' : '全国 区域'
                            }}
                        </div>
                        <!-- <div class="itemViews"><img class="viewsImg" src="/static/images/views.png" alt="">{{item.downloadCount}}</div> -->
                        <!-- <div class="itemViews" v-if="tabType != 1" v-show="stylelId != 3"><img src="/static/images/downLoad.png" alt="">{{item.downloadCount}}</div> -->
                    </div>
                </div>
                <div class="itemDownLoad" v-show="isShowDownloadBtn">
                    <Button type="info" shape="circle" ghost class="downLoadBtn" v-if="item.type == 2" @click="download(item.analysis,item.guid,item.id,item.name,2,item.type,3,2)" >下载</Button>
                    <Button type="info" shape="circle" ghost class="downLoadBtn" v-if="item.type == 3" @click="download(item.analysis,item.guid,item.id,item.name,2,item.type,3,2)" >下载</Button>
                    <Button type="info" shape="circle" ghost class="downLoadBtn" v-if="item.type == 4" @click="download(item.analysis,item.videoId,item.id,item.name,2,item.type,3,2)" >下载</Button>
                    <Button type="info" shape="circle" ghost class="downLoadBtn" v-if="item.type == 1" @click="palyVideo(item.analysis,item.name,1,item.id)">查看</Button>
                </div>
                <div class="itemDownLoad" v-if="tabType == 5">
                    <Button type="info" shape="circle" ghost class="downLoadBtn"  @click="updateDataPPT(item)">共享</Button>
                </div>
                <div class="itemDownLoad"  v-if="tabType == 5">
                    <div @click="remove(item)">删除</div>
                </div>
            </div>
            <div class="page" v-show="pageTotal>6">
                <Page :total="pageTotal" :page-size='6' @on-change="changePage" :current.sync="currentPage"/>
            </div>
        </List>
        <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
        <updata-data :isShow="isShowUpdate" :datas="updateData" @closeUpDate="closeUpdate"></updata-data>
    </div>
</template>

<script>
import  api from '../../utils/api.js'
import bus from '../../assets/eventBus/enentBus.js'
import empty from '../Empty/Empty.vue'
import message from '../Message/Message.vue'
import cookie from '../../assets/getCookie.js'
import statistic from '../../assets/statistics.js'
import updataData from '../Message/updataData'
export default {
    name:'srTabView',
    props:{
        toMaterialId:{
            type:Number,
            default:''
        },
        isAreaResources:{           // true 为同步资源  false 区域共享资源 不显示课堂资源
            type:Boolean,
            default:true
        }
    },
    watch:{
        toMaterialId(newVal,oldVal){
            if(newVal == 0){
                this.isEmpty = true;
            }else{
                this.isEmpty = false;
            }
        }
    },
    data(){
        return{
            url:'/axt-future/knowledgeResource/pageKnowledgeResourceByCondition/?orderBys%5B0%5D.field=createTime&orderBys%5B0%5D.direction=desc',                                               //接口地址
            dataInfo:null,
            imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
            pageTotal:0,                                         //资源总数
            pageOne:1,                                              //学堂资源页数 记录
            pageTwo:1,                                              //全国资源页数 记录
            pageThree:1,                                            //区域之源页数 记录
            pageFour:1,                                             //校本资源页数 记录
            pageFive:1,                                             //我的资源页数 记录
            tabType:'1',                                              // 记录页签位置
            gradeId:83,                                           //年级id  通过筛选按钮传过来
            versionId:4,                                         //版本id  通过筛选按钮传过来
            subjectId:80,                                         //学科id  通过筛选按钮传过来
            stylelId:1,                                             //类型  默认为课件  
            isEmpty:true,                                           //数据是否为空   true：显示无数据图片
            knowledgeId:null,                                       //点击节 id
            materialId:362,                                        //教材id
            isNewClick:false,                                       //是否点击排序按钮
            isViewClick:false,                                       //是否点击排序按钮
            isDownClick:false,                                       //是否点击排序按钮
            isShowUpload:false,                                         //是否显示上传组件  false 不显示,
            websiteId:null,                                             //区域id
            shareSchoolId:null,                                         //学校id
            teacherId:null,                                             //教师id
            field:null,
            msg:null,
            isShowMessage:false,
            isShowDownloadBtn:false,                                     //是否显示下载按钮  登录 之后 显示
            gradeIdLong:'29646e10bec311e3a26400215e3f0e60',
            subjectIdLong:'ff80808127d77caa0127d7e10f1c00c4',
            userType:null,
            tab1:true,
            tab2:false,
            tab3:false,
            tab4:false,
            tab5:false,
            level:1,                                        //默认为第一级
            currentPage:2,                                  //默认第一页
            teacherName:[],
            isShowUpdate:false,
            updateData:{}
        }
    },
     created(){
        const that = this;
        bus.$off('isEmpty');
        bus.$on('isEmpty',function(msg){
            if(msg){
                that.isEmpty = true;
            }
        })
        bus.$off('tbMaterialId');
        bus.$on('tbMaterialId',function(msg){
            that.materialId = msg;
        })
        bus.$off('knowledgeId');
        bus.$on('knowledgeId',function(msg){
            // console.log(msg)
            that.knowledgeId = msg.knowladgeId;
            that.currentPage = 1;
            that.level = msg.level;
            if(that.tabType == 1){
                that.getData(1,that.knowledgeId,that.level)
            }
            if(that.tabType == 2) {
                that.getNetData(1,that.knowledgeId,that.level);
            }
            if(that.tabType == 3){
                that.getAreaData(1,that.knowledgeId,that.level);
            } 
            if(that.tabType == 4){
                that.getSchoolData(1,that.knowledgeId,that.level);
            } 
            if(that.tabType == 5){
                that.getMyData(1,that.knowledgeId,that.level);
            } 
        })
    },
    mounted(){
        this.websiteId = localStorage.getItem('websiteId');
        const cookie_token = cookie.getCookie('AXY_'+ this.websiteId +'_access_token')
        if(cookie_token){
            if(cookie_token != 'null'){
                this.isShowDownloadBtn = true;
                this.shareSchoolId = localStorage.getItem('schoolId');
                this.teacherId = localStorage.getItem('userId');
                this.userType = localStorage.getItem('userType')
            }
        }else{
            this.isShowDownloadBtn = false;
            this.shareSchoolId = null;
            this.teacherId = null;
        }
    },
    methods:{
            //学堂资源
            getData(pageNo,knowladgeId,level){
                this.dataInfo = null
               const that = this;
                var params = {
                    pageNo:pageNo,
                    pageSize:6,      
                    websiteId:this.websiteId,                                  //教材id
                    res_knowledges:knowladgeId,
                    res_knowledgeLevel:level
                    // orderBys:[{
                    //     direction: 'asc',
                    //         field: 'createTime'
                    // }]
                }
                // params = this.$qs.stringify(params)
                api.getListAPI(this.url,params).then(res => {
                    if (res.data.success) {
                        if(res.data.data.total == 0 || res.data.data == null){
                            that.isEmpty = true;
                            that.pageTotal = 0;
                            that.dataInfo = null;
                        }else{
                            that.isEmpty = false;
                            that.pageTotal = res.data.data.total;
                            that.dataInfo = res.data.data.rows;
                        }
                    }else{
                        // that.$Message.error(res.data.message);
                    }
                    
                }).catch(err => {
                    console.log(err)
                })
            },
            //全国资源
            getNetData(pageNo,knowladgeId,level){
                const that = this;
                const params = {
                    pageNo:pageNo,
                    pageSize:6,
                    res_knowledge_level:level,                                          //教材id
                    res_knowledge_id:knowladgeId,
                    shareNetId:1
                }
                api.getListAPI(this.url,params).then(res => {
                    console.log('信息',res)
                    if (res.data.success) {
                        if(res.data.data.total == 0 || res.data.data == null){
                            that.isEmpty = true;
                            that.pageTotal = 0;
                        }else{
                            that.isEmpty = false;
                            that.teacherName = []
                            that.getTeacherName(res.data.data.rows)
                            that.pageTotal = res.data.data.total;
                        }
                    }else{
                        // that.$Message.error(res.data.message);
                    }

                }).catch(err => {
                    console.log(err)
                })
            },
            getAreaData(pageNo,knowladgeId,level){
                const that = this;
                const params = {
                    pageNo:pageNo,
                    pageSize:6,
                    res_knowledge_level:level,                                          //教材id
                    res_knowledge_id:knowladgeId,
                    shareWebsiteId: this.websiteId                                    //区域id
                }
                api.getListAPI(this.url,params).then(res => {
                    if (res.data.success) {
                        if(res.data.data.total == 0 || res.data.data == null){
                            that.isEmpty = true;
                            that.pageTotal = 0;
                        }else{
                            that.isEmpty = false;
                            that.pageTotal = res.data.data.total;
                            that.getTeacherName(res.data.data.rows)
                        }
                    }else{
                        // that.$Message.error(res.data.message);
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            getSchoolData(pageNo,knowladgeId,level){
                const that = this;
                const params = {
                    pageNo:pageNo,
                    pageSize:6,
                    res_knowledge_level:level,                                          //教材id
                    res_knowledge_id:knowladgeId,
                    shareSchoolId: this.shareSchoolId                                     //学校id
                }
                api.getListAPI(this.url,params).then(res => {
                    if (res.data.success) {
                        if(res.data.data.total == 0 || res.data.data == null){
                            that.isEmpty = true;
                            that.pageTotal = 0;
                        }else{
                            that.isEmpty = false;
                            that.pageTotal = res.data.data.total;
                            that.getTeacherName(res.data.data.rows)
                        }
                    }else{
                        // that.$Message.error(res.data.message);
                    }

                })
            },
            getMyData(pageNo,knowladgeId,level){
                const that = this;
                const params = {
                    pageNo:pageNo,
                    pageSize:6,
                    res_knowledge_level:level,                                          //教材id
                    res_knowledge_id:knowladgeId,
                    teacherId: this.teacherId                                       //教师id
                }
                api.getListAPI(this.url,params).then(res => {
                    console.log('我的资源',res.data)
                    if (res.data.success) {
                        if(res.data.data.total == 0 || res.data.data == null){
                            that.isEmpty = true;
                            that.pageTotal = 0;
                        }else{
                            that.isEmpty = false;
                            that.pageTotal = res.data.data.total;
                            that.dataInfo = res.data.data.rows;
                        }
                    }else{
                        // that.$Message.error(res.data.message);
                    }

                }).catch(err => {
                    console.log(err)
                })
            },
            //获取教师名字
            async getTeacherName(info){
                 const url = '/axt-crm/teacher/getTeacherInfoById';
                const obj = info
                var data = {}
                for(let i = 0; i < obj.length; i++){
                    data.teacher_id = obj[i].teacherId
                    await api.getListAPI(url,data).then(res => {
                        obj[i].teacherName = res.data.data.name
                        obj[i].teacherSchool = res.data.data.schoolName
                    })
                }
                this.dataInfo = obj
            },
            updateDataPPT(res){
                console.log('共享',res.type)
                this.updateData = {}
                this.updateData.type = res.type
                this.updateData.guid = res.id
                if(res.shareNetId != 0) this.updateData.shareNetId = 1
                if(res.shareSchoolId != 0 )  this.updateData.shareSchoolId = this.shareSchoolId
                if(res.shareWebsiteId != 0 )  this.updateData.shareWebsiteId = this.websiteId
                this.isShowUpdate = true
            },
            remove(res){
                var url = ''
                const that = this;
                let params = {} 
                if(res.type == 3) {
                    url = '/axt-data/dataLearningPlan/updateDataLearningPlan'
                    params.guid = res.id
                    params.isDelete = 1
                } 
                if(res.type == 2) {
                    url = '/axt-data/dataPPT/updateDataPPT'
                    params.guid = res.id
                    params.status = 0
                } 
                if(res.type == 1) {
                    url = '/axt-data/dataVideo/updateDataVideo'
                    params.id = res.id
                    params.isDelete = 1
                } 
                if(res.type == 4) {
                    url = '/axt-data/dataAudio/updateDataAudio'
                    params.id = res.id
                    params.isDelete = 1
                } 
                api.postParamsAPI(url,params).then(res => {
                    console.log('删除',res)
                    if(res.data.message == 'success'){
                        that.isShowMessage = true
                        that.msg = '删除成功'
                        that.getMyData(1,that.knowledgeId,that.level);
                    }
                })
            },
            //切换tab
            choseTab(name){
                this.currentPage = 1;
                this.pageTotal = 0;
                this.dataInfo = [];
                if(name == 1){
                    this.url =  '/axt-future/knowledgeResource/pageKnowledgeResourceByCondition/?orderBys%5B0%5D.field=createTime&orderBys%5B0%5D.direction=desc';            //学堂资源
                    
                }else{
                    this.url =  '/axt-data/dataResource/pageDataResource/?orderBys%5B0%5D.field=createTime&orderBys%5B0%5D.direction=desc';            //区域之源
                }

                if(name == 1){
                    this.tab1 = true;
                    this.tab2 = false;
                    this.tab3 = false;
                    this.tab4 = false;
                    this.tab5 = false;
                    this.getData(1,this.knowledgeId,this.level);
                }
                if(name == 2){
                    this.tab1 = false;
                    this.tab2 = true;
                    this.tab3 = false;
                    this.tab4 = false;
                    this.tab5 = false;
                    this.getNetData(1,this.knowledgeId,this.level);
                }
                if(name == 3){
                    this.tab1 = false;
                    this.tab2 = false;
                    this.tab3 = true;
                    this.tab4 = false;
                    this.tab5 = false;
                    this.getAreaData(1,this.knowledgeId,this.level);
                }
                if(name == 4){
                    if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                        this.isShowMessage = true;
                        this.msg = ('您尚未登录');
                        return false
                    }
                    this.tab1 = false;
                    this.tab2 = false;
                    this.tab3 = false;
                    this.tab4 = true;
                    this.tab5 = false;
                    this.getSchoolData(1,this.knowledgeId,this.level);
                }
                if(name == 5){
                    if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                        this.isShowMessage = true;
                        this.msg = ('您尚未登录');
                        return
                    }
                    this.tab1 = false;
                    this.tab2 = false;
                    this.tab3 = false;
                    this.tab4 = false;
                    this.tab5 = true;
                    this.getMyData(1,this.knowledgeId,this.level);
                }
                 this.tabType = name;
            },
            //切换页签
            changePage(page){
                if(this.tabType == 1){
                    this.pageOne = page;
                    this.getData(this.pageOne,this.knowledgeId,this.level)
                }
                if(this.tabType == 2) {
                    this.pageTwo = page;
                    this.getNetData(this.pageTwo,this.knowledgeId,this.level);
                }
                if(this.tabType == 3){
                    this.pageThree = page;
                    this.getAreaData(this.pageThree,this.knowledgeId,this.level);
                } 
                if(this.tabType == 4){
                    this.pageFour = page;
                    this.getSchoolData(this.pageFour,this.knowledgeId,this.level);
                } 
                if(this.tabType == 5){
                    this.pageFive = page;
                    this.getMyData(this.pageFive,this.knowledgeId,this.level);
                } 


            },
            download(url,id,materialId,name,source,materialType,access,operateType){
                var materialSource;
                if(this.tabType == 1){
                    materialSource = 1
                }else{
                    materialSource = 2
                }
                const downloadUrl = 'http://qcban.aixuetang.com/res'+ url;
                // const downloadUrl = 'http://192.168.0.52:9880/jsznjypt/res'+ url;
                window.open(downloadUrl)
                statistic.statistics(materialId,name,source,materialType,access,operateType)
                if(this.tabType != 1){                      //非 学堂资源
                    if(this.stylelId == 1){
                        var userDownLoadUrl = '/axt-data/dataPPT/useDataPPT' ;
                        var params = {
                            guid:id,
                            type:2
                        }
                    } 
                    if(this.stylelId == 2){
                        var userDownLoadUrl = '/axt-data/dataLearningPlan/useDataLearningPlan' 
                        var params = {
                            guid:id,
                            type:2
                        }
                    } 
                    if(this.stylelId == 3){
                        var userDownLoadUrl = '/axt-data/dataVideo/useDataVideo' 
                        var userDownLoadUrl = '/axt-data/dataLearningPlan/useDataLearningPlan' 
                        var params = {
                            guid:id,
                            type:2
                        }
                    } 
                    if(this.stylelId == 4){
                        var userDownLoadUrl = '/axt-data/dataAudio/useDataAudio'
                        var params = {
                            video_id:id,
                            type:2
                        }
                    }  
                }
                // api.postFormAPI('http://192.168.0.25:8090/axt-data/dataVideo/useDataVideo',params).then(res =>{
                //     console.log(res)
                // })
            },
            view(url,id,name,soure,materialType,access,operateType){
                if(this.shareSchoolId == null || this.shareSchoolId == undefined){
                    this.isShowMessage = true;
                    this.msg = ('您尚未登录');
                    this.tabType = number;
                    return false
                }
                var materialSource;
                if(this.tabType == 1){
                    materialSource = 1
                }else{
                    materialSource = 2
                }
                this.$emit("isplay",true)
                if (/\.ppt/gi.test(url) || /\.pptx/gi.test(url)
                    || /\.doc/gi.test(url) || /\.docx/gi.test(url)
                    || /\.xls/gi.test(url) || /\.xlsx/gi.test(url)
                    || /\.jpg/gi.test(url) || /\.png/gi.test(url)
                    || /\.pdf/gi.test(url)) {
                         const materialData = {
                            src:url,
                            id:id,
                            name:name,
                            soure:materialSource,
                            materialType:materialType,
                            access:access,
                            operateType:operateType
                        }
                        this.getMaterialUrl(materialData);
                }else {
                    const src = 'https://qcban.aixuetang.com/res' + url;
                    const materialData = {
                        src:src,
                        id:id,
                        name:name,
                        soure:materialSource,
                        materialType:materialType,
                        access:access,
                        operateType:operateType
                    }
                    bus.$emit('materialSrc',materialData)
                }
            },
            getMaterialUrl(src){
                const that = this;
                const url =  '/axt-resources/preview/selectDocumentPreviewUrl';
                const params = {
                    'downloadUrl':src.src
                }
                api.getListAPI(url,params).then(res => {
                    let datas = src;
                    datas.src = res.data.data;
                    bus.$emit('materialSrc',datas)
                })
            },
            palyVideo(videoId,name,sourse,id){
                this.$emit('showPlayer',true)
                var materialSource;
                if(this.tabType == 1){
                    materialSource = 1
                }else{
                    materialSource = 2
                }
                const vidoeData = {
                    videoId:videoId,
                    name:name,
                    sourse:materialSource,
                    id:id
                }
                this.$nextTick(() => {
                    bus.$emit('videoId',vidoeData)
                })
            },
            //排序  1：最新  2：浏览量  3：下载量
            Sort(num){
                if(num == 1){
                    this.isNewClick = true;
                    this.isDownClick = false;
                    this.field = 'createTime'
                }
                if(num == 2){
                    this.isViewClick = true;
                    this.field = 'countCheck'
                }
                if(num == 3){
                    this.isDownClick = true;
                    this.isNewClick = false;
                    this.field = 'countDownload'
                }
                this.choseTab(this.tabType)
            },
            upLoad(){
                const data = {
                    'upLoadKnowledgeId':this.knowledgeId,
                    'upLoadStylelId':this.stylelId,
                    'upLoadGradeId':this.gradeId,
                    'upLoadSubjectId':this.subjectId,
                    'upLoadGradeIdLong':this.gradeIdLong,
                    'upLoadSubjectIdLong':this.subjectIdLong,
                    'upLoadVersionId':this.versionId
                }
                // bus.$emit('upLoadKnowledgeId',this.knowledgeId); 8a9ab004701172fd017013308c100001
                // bus.$emit('upLoadStylelId',this.stylelId);
                // bus.$emit('upLoadGradeId',this.gradeId);
                // bus.$emit('upLoadSubjectId',this.subjectId);
                // bus.$emit('upLoadGradeIdLong',this.gradeIdLong);
                // bus.$emit('upLoadSubjectIdLong',this.subjectIdLong);
                // bus.$emit('upLoadVersionId',this.versionId);
                this.$emit('isUpload',true);
                this.$emit('upLoadData',data)

            },
            isShowMsg(msg){
                this.isShowMessage = false;
            },
            closeUpdate(res){
                const that = this
                this.isShowUpdate = false
                if(res == 'sure'){
                    this.isShowMessage = true
                    this.msg = '共享成功'
                    setTimeout(function(){
                        that.getMyData(that.pageFive,that.knowledgeId,that.level);
                    },800)
                }
            }
        },
        components:{empty,message,updataData}
}
</script>
<style lang="">
    .srContent{
       width:80%;
       margin-left:3%;
       position: relative;
       border-top: solid 2px #3583FF;
        border-bottom: 1px solid #DADADA;
        border-right: 1px solid #DADADA;
        border-left: 1px solid #DADADA;
    }
    .srContentView{
        width:80%!important;
    }
    .sortBox{
        width:10%;
        height: 32px;
        position: absolute;
        top: 0;
        right: 0;
        display:flex;
        flex-direction: row;
    }
    .sortFlex{
        flex: 1;
        justify-content: center;
        text-align: center;
        font-size: 14px;
        line-height: 49px;
        z-index: 10;
    }
    .sortFlex:hover{
        cursor: pointer;
        color: #3583FF;
    }
    .sortFlex:hover .sortFlex img{
        background: #3583FF;
    }
    .sortFlex img{
        width:15px;
        height: 12px;
    }
    .srContent .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active{
        color: #3683FF;
    }
    .srContent .ivu-list-item-meta-content{
        text-align: left;
    }
    .srContent .downLoadBtn{
        width:75px;
        height: 32px;
        /* border-radius: 16px; */
        font-size: 14px;
        line-height: 0;
    }
     .itemDownLoad{
        margin-right: 20px;
    }
    .itemDownLoad .downLoadBtn:hover{
        background:  #2d8cf0;
        color: #fff;
    }
    .itemDownLoad div{
        color:#9a9a9a;
        font-size: 14px;
    }
    .itemDownLoad div:hover{
        cursor: pointer;
        color:#f03a2d;
    }
    .srContent .listItem{
        width:96%;
        margin: 0 auto;
        height: 108px;
        box-sizing: content-box;
        padding-top: 32px;
        border-bottom: solid 1px #dadada;
        display: flex;
        flex-direction: row;
    }
    .avatar{
        flex:1;
        height: 100%;
        display: table-cell;
        vertical-align: middle;
        text-align: left;
    }
    .avatar img{
        width:65px;
        height:76px;
    }
    .description{
        flex:15;
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-left:10px;
    }
    .description .itemTitle{
        font-size: 16px;
        font-weight: 600;
        color: #34495E;
        line-height: 30px;
    }
    .description .itemTitle:hover{
        cursor: pointer;
        color:#3583FF
    }
    .description .itemPlace, .description .itemNumber{
        display: flex;
        flex-direction: row;
        font-size: 14px;
        font-weight: 500;
        color:#9a9a9a;
        line-height:35px;
        margin-top: 20px;
    }
    .description .itemPlace .itemAuthor{
        padding-right: 35px;
    }
    .description .itemTime,.description .itemViews{
        padding-right: 35px;
        display: table-cell;
        vertical-align: middle;
    }
    .description .itemViews img{
        width:14px;
        height: 14px;
        margin-right: 5px;
    }
    .itemDownLoad{
        flex:1;
        line-height: 108px;
    }
    .newBg,.viewBg,.downBg{
        color:  #3683FF;
    }
    /* 上传 */
    .uploadBox{
        width:96%!important;
        overflow: hidden;
        margin-left: 2%;
        margin-top: 29px;
    }
    .uploadBox .material{
        float:left;
        font-size: 14px;
        color: #9A9A9A;
    }
    .uploadBox .upload{
        display: table-cell;
        vertical-align: middle;
        font-size: 14px;
        color: #F95F30;
        float: right;
    }
    .uploadBox .upload:hover{
        cursor: pointer;
    }
    .uploadBox .upload img{
        width:16px;
        height: 14px;
        display: inline-block;
    }
    .waringMsg{
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .ivu-modal-footer button+button{
        border-radius: 20px;
        padding: 2px 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SRTabView/srTabView.vue